import * as tslib_1 from "tslib";
import { LightingCompositeChunk } from "./LightingCompositeChunk";
/**
 * SpecularCelChunk provides a shading method to add specular cel (cartoon) shading.
 */
var SpecularCelChunk = (function (_super) {
    tslib_1.__extends(SpecularCelChunk, _super);
    /**
     * Creates a new DiffuseCelChunk object.
     * @param levels The amount of shadow gradations.
     * @param baseMethod An optional diffuse method on which the cartoon shading is based. If omitted, DiffuseBasicMethod is used.
     */
    function SpecularCelChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        _this._baseChunk._modulateFunction = function (targetReg, registerCache, sharedRegisters) { return _this.clampSpecular(targetReg, registerCache, sharedRegisters); };
        return _this;
    }
    /**
     * @inheritDoc
     */
    SpecularCelChunk.prototype._activate = function () {
        _super.prototype._activate.call(this);
        if (this._invalid) {
            var index = this._cutoffDataIndex;
            var data = this._shader.fragmentConstantData;
            data[index] = this._method.smoothness;
            data[index + 1] = this._method.specularCutOff;
        }
    };
    /**
     * @inheritDoc
     */
    SpecularCelChunk.prototype._cleanCompilationData = function () {
        _super.prototype._cleanCompilationData.call(this);
        this._cutoffDataRegister = null;
    };
    /**
     * Snaps the specular shading strength of the wrapped method to zero or one, depending on whether or not it exceeds the specularCutOff
     * @param vo The MethodVO used to compile the current shader.
     * @param t The register containing the specular strength in the "w" component, and either the half-vector or the reflection vector in "xyz".
     * @param regCache The register cache used for the shader compilation.
     * @param sharedRegisters The shared register data for this shader.
     * @return The AGAL fragment code for the method.
     */
    SpecularCelChunk.prototype.clampSpecular = function (targetReg, registerCache, sharedRegisters) {
        return "sub " + targetReg + ".y, " + targetReg + ".w, " + this._cutoffDataRegister + ".y\n" +
            "div " + targetReg + ".y, " + targetReg + ".y, " + this._cutoffDataRegister + ".x\n" +
            "sat " + targetReg + ".y, " + targetReg + ".y\n" +
            "sge " + targetReg + ".w, " + targetReg + ".w, " + this._cutoffDataRegister + ".y\n" +
            "mul " + targetReg + ".w, " + targetReg + ".w, " + targetReg + ".y\n";
    };
    /**
     * @inheritDoc
     */
    SpecularCelChunk.prototype._getFragmentPreLightingCode = function (registerCache, sharedRegisters) {
        this._cutoffDataRegister = registerCache.getFreeFragmentConstant();
        this._cutoffDataIndex = this._cutoffDataRegister.index * 4;
        return _super.prototype._getFragmentPreLightingCode.call(this, registerCache, sharedRegisters);
    };
    return SpecularCelChunk;
}(LightingCompositeChunk));
export { SpecularCelChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/SpecularCelChunk.js